import React from 'react';
import { Container, Typography, Box, Button, Paper } from '@mui/material';

const CoddingOpportunities = () => {
  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 6, borderRadius: 3 }}>
        <Box textAlign="center">
          <Typography variant="h3" gutterBottom>
            Bienvenido a
          </Typography>
          <Typography variant="h2" color="primary" gutterBottom sx={{ fontWeight: 'bold' }}>
            CoddingOpportunities
          </Typography>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            Esto es solo un template para que dentro de esta pagina se hace el desarrollo
          </Typography>

          <Box mt={4}>
            <Button variant="contained" size="large" color="primary">
              Explorar oportunidades
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default CoddingOpportunities;
